import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Reveal } from '../components/Reveal';

const FAQS: Array<{ q: string; a: string }> = [
  {
    q: 'Do I need my own email service?',
    a: 'No. Just connect your domain — we handle SPF, DKIM, and DMARC under the hood. Setup takes about 5 minutes (most of which is waiting for your DNS to propagate).',
  },
  {
    q: 'Can AI agents really send emails through SendFast?',
    a: 'Yes. We expose a Model Context Protocol (MCP) server alongside a clean REST API. Claude Desktop, Cursor, ChatGPT (via custom GPT/agent), and any MCP-aware client can draft, edit, screenshot, and send emails using natural language.',
  },
  {
    q: 'What happens to the prompts and email I generate?',
    a: 'They stay in your account. We use AI providers with zero-retention agreements. You can delete any draft (and its versions) at any time.',
  },
  {
    q: 'Will my email render correctly in Outlook and Gmail?',
    a: 'Yes. We force inline-styled <table> layouts based on proven email patterns from MJML and major ESPs — not React-style markup that breaks in older clients.',
  },
  {
    q: 'What if I hit the Free limit?',
    a: "Join the Pro waitlist. We're also granting bonus capacity case-by-case to early users — drop us a line.",
  },
  {
    q: 'Can I export or migrate my emails?',
    a: 'Yes — every draft can be exported as raw HTML and copied into Klaviyo, Mailchimp, HubSpot, or wherever. We never hold your content hostage.',
  },
];

export function FAQ() {
  return (
    <section id="faq" className="border-border bg-muted/60 border-y py-24 lg:py-32">
      <div className="mx-auto max-w-[900px] px-6 lg:px-10">
        <Reveal>
          <p className="text-muted-foreground text-xs uppercase tracking-[0.18em]">FAQ</p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="font-display mt-3 text-4xl font-semibold tracking-tight md:text-5xl">
            Questions, answered.
          </h2>
        </Reveal>

        <Reveal delay={120} className="mt-12">
          <Accordion type="single" collapsible className="grid gap-3">
            {FAQS.map((f) => (
              <AccordionItem
                key={f.q}
                value={f.q}
                className="bg-card rounded-xl border px-6 last:border-b"
              >
                <AccordionTrigger className="text-base font-medium tracking-tight hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
